import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,{staticClass:"breadcrumb-container",class:{ 'has-items': _vm.store.items.length > 0 }},[_c(VBreadcrumbs,{attrs:{"items":_vm.store.items},scopedSlots:_vm._u([{key:"divider",fn:function(){return [_c('font-awesome-icon',{attrs:{"icon":['fas', 'chevron-right']}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }